import { UILocation } from '../redux/reducers/app-reducers';
import { delayedRedirect } from '../redux/actions/app-actions';
import { isAdmin, isStudent, isTeacher } from '../constants/roles';
import { isLTIResourceRequest } from '../remote/lti';
import { useBaseRole } from '../utils/utils';
import { useClientDispatch, useClientSelector } from '@/redux/hooks';

export const Navigation = () => {
  const baseRole = useBaseRole();
  const dispatch = useClientDispatch();

  const newUser = useClientSelector(state => state.firebase.newUser);
  const authUser = useClientSelector(state => state.firebase.authUser);
  const location = useClientSelector(state => state.app.location);
  const ltiEnv = useClientSelector(state => state.app.ltiEnv);
  const redirectToTeacherHome = useClientSelector(state => state.adminUI.redirectToTeacherHome);

  const setLocation = (newLocation: UILocation) => {
    if (location !== newLocation) {
      setTimeout(() => dispatch(delayedRedirect({ location: newLocation })));
    }
  };

  if (location === UILocation.forgotPassword) {
    return null;
  }

  if (!authUser?.firebaseUser) {
    if (location !== UILocation.signup) {
      setLocation(UILocation.signin);
    }
  } else if (authUser?.firebaseUser && newUser) {
    setLocation(ltiEnv ? UILocation.noRole : UILocation.newAccount);
  } else if (ltiEnv && !authUser?.claims?.context.id) {
    setLocation(UILocation.noContext);
  } else if (isTeacher(baseRole)) {
    if (isLTIResourceRequest()) {
      setLocation(UILocation.resources);
    } else {
      setLocation(isAdmin(baseRole) && !redirectToTeacherHome ? UILocation.admin : UILocation.teacherHome);
    }
  } else if (isStudent(baseRole)) {
    setLocation(UILocation.studentHome);
  } else {
    setLocation(UILocation.noRole);
  }

  return null;
};
